import React from 'react';
import EnvironmentContext from './EnvironmentContext';

export default function useEnvironment()
{
    return React.useContext(EnvironmentContext);
}